export const parseCurrency = (price) => {
	return `${(price / 100).toFixed(2).split('.').join(',') } €`
}

export const months = {
   '1': 'TAMMI',
   '2': 'HELMI',
   '3': 'MAALIS',
   '4': 'HUHTI',
   '5': 'TOUKO',
   '6': 'KESÄ',
   '7': 'HEINÄ',
   '8': 'ELO',
   '9': 'SYYS',
   '10': 'LOKA',
   '11': 'MARRAS',
   '12': 'JOULU'
}

const formatToDateString = (date) => {
	const year= date.getFullYear();
	const month= date.getMonth() + 1;
	const day= date.getDate();
	return `${day}.${month}.${year}`
}
const formatToTimeString = (date) => {
	const hours= date.getHours();
	const minutes= date.getMinutes()

	return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
}

export const formatDate = (date) => {
	const dateObject = date ? (date.toDate ? date.toDate() : date._seconds ? new Date(date._seconds * 1000): date) : null
	return dateObject ? formatToDateString(dateObject) : null
}

export const convertToTimestamp = (date) => {
	return date ? (date.toDate ? date.toDate() : date._seconds ? new Date(date._seconds * 1000): date) : null
}

export const formatTime = (date) => {
	const dateObject = date ? (date.toDate ? date.toDate() : date._seconds ? new Date(date._seconds * 1000): date) : null
	return dateObject ? formatToTimeString(dateObject) : null
}

export function toSlug(st){
	return st.toString()
		.toLowerCase()
		.replace(/[\u00C0-\u00C5]/ig,'a')
		.replace(/[\u00C8-\u00CB]/ig,'e')
		.replace(/[\u00CC-\u00CF]/ig,'i')
		.replace(/[\u00D2-\u00D6]/ig,'o')
		.replace(/[\u00D9-\u00DC]/ig,'u')
		.replace(/[\u00D1]/ig,'n')
		.replace(/\s+/g, '-') // Replace spaces with -
		.replace(/&/g, '-') // Replace & with '-'
		.replace(/\./g, '-') // Replace . with '-'
		.replace(/\:/g, '-and-') // Replace : with '-'
		.replace(/[^\w\-]+/g, '') // Remove all non-word characters
		.replace(/\-\-+/g, '-') // Replace multiple - with single -
		.replace(/^-+/, '') // Trim - from start of text
		.replace(/-+$/, '') // Trim - from end of text

}



// WEBPACK FOOTER //
// ./helpers.js